import React from "react";
import { Radio } from "antd";
import "./AntdRadioSelect.css";

const RadioSelect = (props) => {
  const { onObjectivesToDiscussChange, value, name } = props;

  return (
    <>
      <Radio.Group
        onChange={onObjectivesToDiscussChange}
        value={value}
        name={name}
        style={{ display: "flex", marginTop: "16px" }}
      >
        <Radio value="false">No thanks</Radio>
        <Radio value="true">Yes please</Radio>
      </Radio.Group>
    </>
  );
};

export default RadioSelect;
